export default __webpack_public_path__ + "static/media/DouglasLopes_03.8c4b45c0.jpg";